import SideBar from './components/sidebar';
import {
	createBrowserRouter,
	createRoutesFromElements,
	Route,
	RouterProvider,
	Routes,
	useLocation,
} from 'react-router-dom';
import Home from './pages/home';
import ReactMemo from './pages/react-memo';
import UseMemo from './pages/use-memo';
import { GitHubLink } from './mock/static-data';
import { BsGithub } from 'react-icons/bs';
import UseCallBack from './pages/use-callback';
import LazyImageLoad from './pages/lazy-image-load';
import InfinityScroll from './pages/infinity-scroll';
import DebounceInput from './pages/debounce-input';
import ReactQuery from './pages/react-query';
import TypeScript from './pages/typescript';
import JsArrays from './pages/js-arrays';
import InfinityScrollTwo from './pages/infinity-scroll-two';
import OtherPage from './pages/other-page';
import ErrorBoundary from './components/error-boundary';
import Layout from './common/layout';
import UseClickOutsidePage from './pages/use-click-outside';
import PlayGround from './pages/playground';
import UserReducer from './pages/use-reducer';
import UseMemoTwo from './pages/use-memo-two';
import UseTransition from './pages/use-transition';

// const routesFromElements = createRoutesFromElements(
// 	<Route element={<Layout />}>
// 		<Route
// 			index
// 			element={<Home />}
// 		/>
// 		<Route
// 			path="/other"
// 			element={<OtherPage />}
// 			errorElement={<ErrorBoundary />}
// 		/>
// 		<Route
// 			path="/use-click-outside"
// 			element={<UseClickOutsidePage />}
// 		/>
// 	</Route>,
// );

// const router = createBrowserRouter(routesFromElements);

function App() {
	// return <RouterProvider router={router} />;
	const route = useLocation().pathname;
	return (
		<div>
			<SideBar>
				<div className="mb-7 mr-5 fixed z-[999] right-0">
					{route !== '/' && (
						<a
							href={`${GitHubLink}${route}.tsx`}
							target="_blank"
							rel="noreferrer"
							className="bg-gray-700 rounded-md px-3 py-2 hover:bg-gray-600 transition-all duration-300 ease-in-out text-sm font-[600] flex items-center gap-1"
						>
							view code on <BsGithub />
						</a>
					)}
				</div>
				<Routes>
					<Route
						path="/"
						element={<Home />}
					/>
					<Route
						path="/playground"
						element={<PlayGround />}
					/>
					<Route
						path="/use-reducer"
						element={<UserReducer />}
					/>
					<Route
						path="/use-memo-two"
						element={<UseMemoTwo />}
					/>
					<Route
						path="/use-transition"
						element={<UseTransition />}
					/>
					<Route
						path="/react-memo"
						element={<ReactMemo />}
					/>
					<Route
						path="/use-memo"
						element={<UseMemo />}
					/>
					<Route
						path="/use-callback"
						element={<UseCallBack />}
					/>
					<Route
						path="/lazy-image-load"
						element={<LazyImageLoad />}
					/>
					<Route
						path="/infinity-scroll"
						element={<InfinityScroll />}
					/>
					<Route
						path="/infinity-scroll-two"
						element={<InfinityScrollTwo />}
					/>
					<Route
						path="/debounce-input"
						element={<DebounceInput />}
					/>
					<Route
						path="/react-query"
						element={<ReactQuery />}
					/>
					<Route
						path="/typescript"
						element={<TypeScript />}
					/>
					<Route
						path="/js-arrays"
						element={<JsArrays />}
					/>
					<Route
						path="/use-click-outside"
						element={<UseClickOutsidePage />}
					/>
					{/* <Route
						path="/other-page"
						element={<OtherPage />}
						errorElement={<ErrorBoundary />}
					/> */}
				</Routes>
			</SideBar>
		</div>
	);
}

export default App;
